import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';


const IconHamburger = ({ width = 24, height = 24, viewBox = '0 0 24 24', color = colors.black }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M21 17V20H3V17H21ZM21 11V14H3V11H21ZM21 5V8H3V5H21Z' fill={color} />
    </svg>;
};

IconHamburger.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    viewBox: PropTypes.string
};

export default IconHamburger;
